import api from "./api";

const dealerApi = {
    // Get all dzongkhags
    getDzongkhags: async () => {
        try {
            const response = await api.get('/dealers/dzongkhags');
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    // Get all dealers (optionally filtered by dzongkhagId)
    getAll: async (dzongkhagId) => {
        try {
            const params = dzongkhagId ? { dzongkhagId } : {};
            const response = await api.get('/dealers', { params });
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    // Get dealers grouped by dzongkhag
    getDealersByDzongkhag: async () => {
        try {
            const response = await api.get('/dealers/by-dzongkhag');
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    // Get single dealer by ID
    getById: async (id) => {
        try {
            const response = await api.get(`/dealers/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    // Create new dealer
    create: async (dealerData) => {
        try {
            const response = await api.post('/dealers', dealerData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    // Bulk create dealers
    bulkCreate: async (dzongkhagId, dealers) => {
        try {
            const response = await api.post('/dealers/bulk', { dzongkhagId, dealers });
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    // Update dealer
    update: async (id, dealerData) => {
        try {
            const response = await api.put(`/dealers/${id}`, dealerData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    // Delete dealer
    delete: async (id) => {
        try {
            const response = await api.delete(`/dealers/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    // If you need them, you'll need to implement the backend first
};

export default dealerApi;